import { matchPath } from 'react-router-dom';
import type { RemoteRouteManifestEntry } from './types';

export const remoteRouteManifest: RemoteRouteManifestEntry[] = [
  {
    remoteName: 'mfe-products',
    routePath: '/products',
    moduleId: 'productsListRoute',
    contractVersion: '1.0.1',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-products',
    routePath: '/products/deactivated',
    moduleId: 'productsDeactivatedRoute',
    contractVersion: '1.0.1',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-products',
    routePath: '/products/:id',
    moduleId: 'productsDetailRoute',
    contractVersion: '1.0.1',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-upc',
    routePath: '/upc-management',
    moduleId: 'upcManagementRoute',
    contractVersion: '1.0.1',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-upc',
    routePath: '/upc-management/review/:upc',
    moduleId: 'upcReviewRoute',
    contractVersion: '1.0.1',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-upc',
    routePath: '/submit-upc',
    moduleId: 'upcSubmitRoute',
    contractVersion: '1.0.1',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-platform',
    routePath: '/settings',
    moduleId: 'platformSettingsRoute',
    contractVersion: '1.0.0',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-platform',
    routePath: '/settings/field-options',
    moduleId: 'platformFieldOptionsRoute',
    contractVersion: '1.0.0',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-platform',
    routePath: '/auth/start',
    moduleId: 'platformAuthStartRoute',
    contractVersion: '1.0.0',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-platform',
    routePath: '/auth/callback/:provider',
    moduleId: 'platformAuthCallbackRoute',
    contractVersion: '1.0.0',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-platform',
    routePath: '/auth/complete',
    moduleId: 'platformAuthCompleteRoute',
    contractVersion: '1.0.0',
    timeoutMs: 4000,
  },
  {
    remoteName: 'mfe-platform',
    routePath: '/accept-invite',
    moduleId: 'platformAcceptInviteRoute',
    contractVersion: '1.0.0',
    timeoutMs: 4000,
  },
];

export function resolveRemoteRoute(pathname: string): RemoteRouteManifestEntry | null {
  const match = remoteRouteManifest.find((entry) => {
    return matchPath({ path: entry.routePath, end: true }, pathname) !== null;
  });

  return match ?? null;
}
